module.exports = __webpack_public_path__ + "img/iot6.48b63e0b.png";